module.exports = __webpack_public_path__ + "static/media/Spiderweb01.e55029c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/GameTheme/Background/Spiderweb01.png
// module id = 689
// module chunks = 0